function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import z from 'zod';
import { defineDocument } from 'sanity-typed-queries';
import { TaxonomyType } from '@stereoagency/constants';
import profile from './profile.js';
import { arrayEntry, internationalizedArrayPageSections, internationalizedArrayString, sanityReference, documentSlug, internationalizedArraySimpleBlockContent } from '../fragments/index.js';
import { link } from '../objects/index.js';
import taxonomy from './taxonomy.js';
var schema = defineDocument('event', {
    slug: _object_spread({
        title: 'Slug'
    }, documentSlug.factory()),
    title: {
        title: 'Title',
        type: 'internationalizedArrayString'
    },
    content: {
        title: 'Content',
        type: 'internationalizedArrayPageSections'
    },
    datetime: {
        title: 'Date & time',
        type: 'datetime',
        validation: function validation(Rule) {
            return Rule.required();
        }
    },
    timezone: {
        title: 'Timezone',
        type: 'string',
        description: 'Leave blank to use the current timezone',
        options: {
            list: typeof Intl.supportedValuesOf !== 'undefined' ? Intl.supportedValuesOf('timeZone') : []
        }
    },
    duration: {
        title: 'Duration',
        type: 'string',
        description: 'In hours and minutes (eg; 1:00)',
        validation: function validation(Rule) {
            return Rule.regex(/^\d{1,2}:\d{2}$/);
        }
    },
    eventType: {
        title: 'Event Type',
        type: 'reference',
        to: [
            {
                type: 'taxonomy'
            }
        ],
        options: {
            filter: 'type == $type',
            filterParams: {
                type: TaxonomyType.EVENT_TYPE
            }
        }
    },
    taxonomies: {
        title: 'Taxonomies',
        type: 'array',
        description: 'Supports event categories',
        of: [
            {
                type: 'reference',
                to: [
                    {
                        type: 'taxonomy'
                    }
                ],
                options: {
                    filter: 'type in $types',
                    filterParams: {
                        types: [
                            TaxonomyType.EVENT_CATEGORY
                        ]
                    }
                }
            }
        ]
    },
    location: {
        title: 'Location',
        type: 'string'
    },
    organizer: {
        title: 'Organizer',
        type: 'string'
    },
    lecturer: {
        title: 'Lecturer',
        type: 'string'
    },
    lecturerInformation: {
        title: 'Lecturer Information',
        type: 'internationalizedArraySimpleBlockContent'
    },
    contact: {
        title: 'Contact',
        type: 'reference',
        to: [
            {
                type: 'profile'
            }
        ]
    },
    registrationAction: {
        title: 'Registration Action',
        type: 'link'
    }
}, [
    profile.schema.profile,
    link.schema.link,
    taxonomy.schema.taxonomy,
    {},
    {},
    {}
]);
var validator = z.object({
    slug: documentSlug.validator,
    title: internationalizedArrayString.validator,
    content: internationalizedArrayPageSections.validator,
    datetime: z.string(),
    timezone: z.string(),
    duration: z.string(),
    eventType: sanityReference.validator,
    taxonomies: z.array(sanityReference.validator.merge(arrayEntry.validator)),
    location: z.string(),
    organizer: z.string(),
    lecturer: z.string(),
    lecturerInformation: internationalizedArraySimpleBlockContent.validator,
    contact: sanityReference.validator,
    registrationAction: link.validator
}).partial();
schema.event;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=event.js.map